var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sub-title" }, [_vm._v(_vm._s(_vm.name))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-columns pb-4" },
      _vm._l(_vm.serviceAreas, function(serviceArea, index) {
        return _c(
          "div",
          { key: index, staticClass: "card service-area-card" },
          [
            _c(
              "div",
              { staticClass: "card-body service-area-card-body" },
              [
                _c("div", { staticClass: "card-title service-area" }, [
                  _vm._v(_vm._s(serviceArea.name))
                ]),
                _vm._v(" "),
                _vm._l(serviceArea.services, function(service, index) {
                  return _c("div", { key: index, staticClass: "service" }, [
                    _c(
                      "a",
                      {
                        staticClass: "card-text service cursor-pointer",
                        on: {
                          click: function($event) {
                            return _vm.handleClickServiceModal(service)
                          }
                        }
                      },
                      [_vm._v(_vm._s(service.name))]
                    )
                  ])
                })
              ],
              2
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5f65a16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5f65a16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-directory/ServiceDirectoryPlatform.vue
// module id = null
// module chunks = 